import { IRSBusinessActivityCode } from '@taxfyle/txf-api-client'

export const BUSINESS_ACTIVITY_CODES_MAP: Record<
  IRSBusinessActivityCode,
  string
> = {
  [IRSBusinessActivityCode.RoomingBoardingHousesDormitoriesWorkersCamps]:
    "721310 - Rooming & Boarding Houses, Dormitories & Workers' Camps",
  [IRSBusinessActivityCode.RvParksRecreationalCamps]:
    '721210 - RV Parks & Recreational Camps',
  [IRSBusinessActivityCode.TravelerAccomodationsHotelsMotelsBedAndBreakfasts]:
    '721100 - Hotels, Motels & Bed and Breakfasts',
  [IRSBusinessActivityCode.CafeteriasAndBuffets]:
    '722514 - Cafeterias & Buffets',
  [IRSBusinessActivityCode.DrinkingPlacesAlcoholic]:
    '722410 - Drinking Places (Alcoholic)',
  [IRSBusinessActivityCode.FullServiceRestaurants]:
    '722511 - Full-Service Restaurants',
  [IRSBusinessActivityCode.LimitedServiceRestaurants]:
    '722513 - Limited-Service Restaurants',
  [IRSBusinessActivityCode.SnackNonAlcoholicBeverage]:
    '722515 - Snack & Non-Alcoholic Beverage Bars',
  [IRSBusinessActivityCode.SpecialFoodServices]:
    '722300 - Special Food Services',
  [IRSBusinessActivityCode.BusinessServiceCenters]:
    '561430 - Business Service Centers',
  [IRSBusinessActivityCode.CarpetAndUpholsteryCleaningServices]:
    '561740 - Carpet & Upholstery Cleaning Services',
  [IRSBusinessActivityCode.CollectionAgencies]: '561440 - Collection Agencies',
  [IRSBusinessActivityCode.CreditBureaus]: '561450 - Credit Bureaus',
  [IRSBusinessActivityCode.DocumentPreparationServices]:
    '561410 - Document Preparation Services',
  [IRSBusinessActivityCode.EmploymentServices]: '561300 - Employment Services',
  [IRSBusinessActivityCode.ExterminatingAndPestControlServices]:
    '561710 - Exterminating & Pest Control Services',
  [IRSBusinessActivityCode.FacilitiesSupportServices]:
    '561210 - Facilities Support Services',
  [IRSBusinessActivityCode.InvestigationAndSecurityServices]:
    '561600 - Investigation & Security Services',
  [IRSBusinessActivityCode.JanitorialServices]: '561720 - Janitorial Services',
  [IRSBusinessActivityCode.LandscapeServices]: '561730 - Landscape Services',
  [IRSBusinessActivityCode.OfficeAdministrativeServices]:
    '561110 - Office Administrative Services',
  [IRSBusinessActivityCode.TelephoneCallCenters]:
    '561420 - Telephone Call Centers',
  [IRSBusinessActivityCode.TravelArrangementAndReservationServices]:
    '561500 - Travel Arrangement & Reservation Services',
  [IRSBusinessActivityCode.OtherBusinessSupportServices]:
    '561490 - Other Business Support Services',
  [IRSBusinessActivityCode.OtherServicesToBuildingsAndDwellings]:
    '561790 - Other Services to Buildings & Dwellings',
  [IRSBusinessActivityCode.OtherSupportServices]:
    '561900 - Other Support Services',
  [IRSBusinessActivityCode.WasteManagementAndRemediationServices]:
    '562000 - Waste Management & Remediation Services',
  [IRSBusinessActivityCode.AnimalProduction]: '112900 - Animal Production',
  [IRSBusinessActivityCode.Fishing]: '114110 - Fishing',
  [IRSBusinessActivityCode.ForestryAndLogging]: '113000 - Forestry & Logging',
  [IRSBusinessActivityCode.HuntingAndTrapping]: '114210 - Hunting & Trapping',
  [IRSBusinessActivityCode.SupportActivitiesForAnimalProduction]:
    '115210 - Support Activities for Animal Production',
  [IRSBusinessActivityCode.SupportActivitiesForCropProduction]:
    '115110 - Support Activities for Crop Production',
  [IRSBusinessActivityCode.SupportActivitiesForForestry]:
    '115310 - Support Activities for Forestry',
  [IRSBusinessActivityCode.AmusementParksAndArcades]:
    '713100 - Amusement Parks & Arcades',
  [IRSBusinessActivityCode.GamblingIndustries]: '713200 - Gambling Industries',
  [IRSBusinessActivityCode.OtherAmusementAndRecreationServices]:
    '713900 - Other Amusement & Recreation Services',
  [IRSBusinessActivityCode.MuseumsHistoricalSitesAndSimilarInstitutions]:
    '712100 - Museums, Historical Sites & Similar Institutions',
  [IRSBusinessActivityCode.AgentsAndManagersForArtistsAthletesEntertainersAndOtherPublicFigures]:
    '711410 - Agents & Managers for Artists, Athletes & Entertainers',
  [IRSBusinessActivityCode.IndependentArtistsWritersAndPerformers]:
    '711510 - Independent Artists, Writers & Performers',
  [IRSBusinessActivityCode.PerformingArtsCompanies]:
    '711100 - Performing Arts Companies',
  [IRSBusinessActivityCode.PromotersOfPerformingArtsSportsAndSimilarEvents]:
    '711300 - Promoters of Performing Arts, Sports & Similar Events',
  [IRSBusinessActivityCode.SpectatorSports]: '711210 - Spectator Sports',
  [IRSBusinessActivityCode.NonresidentialBuildingConstruction]:
    '236200 - Nonresidential Building Construction',
  [IRSBusinessActivityCode.ResidentialBuildingConstruction]:
    '236100 - Residential Building Construction',
  [IRSBusinessActivityCode.HighwayStreetAndBridgeConstruction]:
    '237310 - Highway, Street & Bridge Construction',
  [IRSBusinessActivityCode.LandSubdivision]: '237210 - Land Subdivision',
  [IRSBusinessActivityCode.UtilitySystemConstruction]:
    '237100 - Utility System Construction',
  [IRSBusinessActivityCode.OtherHeavyAndCivilEngineeringConstruction]:
    '237990 - Other Heavy & Civil Engineering Construction',
  [IRSBusinessActivityCode.DrywallAndInsulationContractors]:
    '238310 - Drywall & Insulation Contractors',
  [IRSBusinessActivityCode.ElectricalContractors]:
    '238210 - Electrical Contractors',
  [IRSBusinessActivityCode.FinishCarpentryContractors]:
    '238350 - Finish Carpentry Contractors',
  [IRSBusinessActivityCode.FlooringContractors]:
    '238330 - Flooring Contractors',
  [IRSBusinessActivityCode.FramingCarpentryContractors]:
    '238130 - Framing Carpentry Contractors',
  [IRSBusinessActivityCode.GlassAndGlazingContractors]:
    '238150 - Glass & Glazing Contractors',
  [IRSBusinessActivityCode.MasonryContractors]: '238140 - Masonry Contractors',
  [IRSBusinessActivityCode.PaintingAndWallCoveringContractors]:
    '238320 - Painting & Wall Covering Contractors',
  [IRSBusinessActivityCode.PlumbingHeatingAndAirConditioningContractors]:
    '238220 - Plumbing, Heating & Air-Conditioning Contractors',
  [IRSBusinessActivityCode.PouredConcreteFoundationAndStructureContractors]:
    '238110 - Poured Concrete Foundation & Structure Contractors',
  [IRSBusinessActivityCode.RoofingContractors]: '238160 - Roofing Contractors',
  [IRSBusinessActivityCode.SidingContractors]: '238170 - Siding Contractors',
  [IRSBusinessActivityCode.SitePreparationContractors]:
    '238910 - Site Preparation Contractors',
  [IRSBusinessActivityCode.StructuralSteelAndPrecastConcreteConstructionContractors]:
    '238120 - Structural Steel & Precast Concrete Contractors',
  [IRSBusinessActivityCode.TileAndTerrazzoContractors]:
    '238340 - Tile & Terrazzo Contractors',
  [IRSBusinessActivityCode.OtherBuildingEquipmentContractors]:
    '238290 - Other Building Equipment Contractors',
  [IRSBusinessActivityCode.OtherBuildingFinishingContractors]:
    '238390 - Other Building Finishing Contractors',
  [IRSBusinessActivityCode.OtherFoundationStructureAndBuildingExteriorContractors]:
    '238190 - Other Foundation, Structure & Building Exterior Contractors',
  [IRSBusinessActivityCode.AllOtherSpecialtyTradeContractors]:
    '238990 - All Other Specialty Trade Contractors',
  [IRSBusinessActivityCode.EducationalServices]:
    '611000 - Educational Services',
  [IRSBusinessActivityCode.DepositoryCreditIntermediation]:
    '522100 - Depository Credit Intermediation',
  [IRSBusinessActivityCode.NondepositoryCreditIntermediation]:
    '522200 - Nondepository Credit Intermediation',
  [IRSBusinessActivityCode.ActivitiesRelatedToCreditIntermediation]:
    '522300 - Activities Related to Credit Intermediation',
  [IRSBusinessActivityCode.InsuranceAgenciesAndBrokerages]:
    '524210 - Insurance Agencies & Brokerages',
  [IRSBusinessActivityCode.OtherInsuranceRelatedActivities]:
    '524290 - Other Insurance Related Activities',
  [IRSBusinessActivityCode.CommodityContractsIntermediation]:
    '523160 - Commodity Contracts Intermediation',
  [IRSBusinessActivityCode.InvestmentBankingAndSecuritiesIntermediation]:
    '523150 - Investment Banking & Securities Intermediation',
  [IRSBusinessActivityCode.SecuritiesAndCommodityExchanges]:
    '523210 - Securities & Commodity Exchanges',
  [IRSBusinessActivityCode.OtherFinancialInvestmentActivities]:
    '523900 - Other Financial Investment Activities',
  [IRSBusinessActivityCode.HomeHealthCareServices]:
    '621610 - Home Health Care Services',
  [IRSBusinessActivityCode.MedicalAndDiagnosticLaboratories]:
    '621510 - Medical & Diagnostic Laboratories',
  [IRSBusinessActivityCode.OfficesOfChiropractors]:
    '621310 - Offices of Chiropractors',
  [IRSBusinessActivityCode.OfficesOfDentists]: '621210 - Offices of Dentists',
  [IRSBusinessActivityCode.OfficesOfMentalHealthPractitioners]:
    '621330 - Offices of Mental Health Practitioners',
  [IRSBusinessActivityCode.OfficesOfOptometrists]:
    '621320 - Offices of Optometrists',
  [IRSBusinessActivityCode.OfficesOfPhysicalOccupationalAndSpeechTherapistsAndAudiologists]:
    '621340 - Offices of Physical, Occupational & Speech Therapists',
  [IRSBusinessActivityCode.OfficesOfPhysiciansExceptMentalHealthSpecialists]:
    '621111 - Offices of Physicians (Except Mental Health)',
  [IRSBusinessActivityCode.OfficesOfPhysiciansMentalHealthSpecialists]:
    '621112 - Offices of Physicians (Mental Health)',
  [IRSBusinessActivityCode.OfficesOfPodiatrists]:
    '621391 - Offices of Podiatrists',
  [IRSBusinessActivityCode.OfficesOfAllOtherMiscellaneousHealthPractitioners]:
    '621399 - Offices of All Other Health Practitioners',
  [IRSBusinessActivityCode.OutpatientCareCenters]:
    '621400 - Outpatient Care Centers',
  [IRSBusinessActivityCode.OtherAmbulatoryHealthCareServices]:
    '621900 - Other Ambulatory Health Care Services',
  [IRSBusinessActivityCode.Hospitals]: '622000 - Hospitals',
  [IRSBusinessActivityCode.NursingAndResidentialCareFacilities]:
    '623000 - Nursing & Residential Care Facilities',
  [IRSBusinessActivityCode.ChildcareServices]: '624410 - Childcare Services',
  [IRSBusinessActivityCode.CommunityFoodAndHousingAndEmergencyAndOtherRelief]:
    '624200 - Community Food, Housing & Emergency Relief',
  [IRSBusinessActivityCode.IndividualAndFamilyServices]:
    '624100 - Individual & Family Services',
  [IRSBusinessActivityCode.VocationalRehabilitationServices]:
    '624310 - Vocational Rehabilitation Services',
  [IRSBusinessActivityCode.PublishingIndustries]:
    '513000 - Publishing Industries',
  [IRSBusinessActivityCode.BroadcastingAndContentProviders]:
    '516000 - Broadcasting & Content Providers',
  [IRSBusinessActivityCode.Telecommunications]: '517000 - Telecommunications',
  [IRSBusinessActivityCode.ComputingInfrastructureProvidersDataProcessingWebHostingAndRelatedServices]:
    '518210 - Computing Infrastructure, Data Processing & Web Hosting',
  [IRSBusinessActivityCode.WebSearchPortalsLibrariesArchivesAndOtherInfoServices]:
    '519200 - Web Search Portals, Libraries & Archives',
  [IRSBusinessActivityCode.MotionPictureAndVideoIndustries]:
    '512100 - Motion Picture & Video Industries',
  [IRSBusinessActivityCode.SoundRecordingIndustries]:
    '512200 - Sound Recording Industries',
  [IRSBusinessActivityCode.ApparelMfg]: '315000 - Apparel Manufacturing',
  [IRSBusinessActivityCode.BeverageAndTobaccoProductMfg]:
    '312000 - Beverage & Tobacco Product Manufacturing',
  [IRSBusinessActivityCode.ComputerAndElectronicProductMfg]:
    '334000 - Computer & Electronic Product Manufacturing',
  [IRSBusinessActivityCode.ElectricalEquipmentApplianceAndComponentMfg]:
    '335000 - Electrical Equipment, Appliance & Component Manufacturing',
  [IRSBusinessActivityCode.FabricatedMetalProductMfg]:
    '332000 - Fabricated Metal Product Manufacturing',
  [IRSBusinessActivityCode.FurnitureAndRelatedProductMfg]:
    '337000 - Furniture & Related Product Manufacturing',
  [IRSBusinessActivityCode.MachineryMfg]: '333000 - Machinery Manufacturing',
  [IRSBusinessActivityCode.MedicalEquipmentAndSuppliesMfg]:
    '339110 - Medical Equipment & Supplies Manufacturing',
  [IRSBusinessActivityCode.PaperMfg]: '322000 - Paper Manufacturing',
  [IRSBusinessActivityCode.PetroleumAndCoalProductsMfg]:
    '324100 - Petroleum & Coal Products Manufacturing',
  [IRSBusinessActivityCode.PlasticsAndRubberProductsMfg]:
    '326000 - Plastics & Rubber Products Manufacturing',
  [IRSBusinessActivityCode.PrimaryMetalMfg]:
    '331000 - Primary Metal Manufacturing',
  [IRSBusinessActivityCode.PrintingAndRelatedSupportActivities]:
    '323100 - Printing & Related Support Activities',
  [IRSBusinessActivityCode.TextileMills]: '313000 - Textile Mills',
  [IRSBusinessActivityCode.TextileProductMills]:
    '314000 - Textile Product Mills',
  [IRSBusinessActivityCode.TransportationEquipmentMfg]:
    '336000 - Transportation Equipment Manufacturing',
  [IRSBusinessActivityCode.WoodProductMfg]:
    '321000 - Wood Product Manufacturing',
  [IRSBusinessActivityCode.OtherMiscellaneousMfg]:
    '339900 - Other Miscellaneous Manufacturing',
  [IRSBusinessActivityCode.BasicChemicalMfg]:
    '325100 - Basic Chemical Manufacturing',
  [IRSBusinessActivityCode.PaintCoatingAndAdhesiveMfg]:
    '325500 - Paint, Coating & Adhesive Manufacturing',
  [IRSBusinessActivityCode.PesticideFertilizerAndOtherAgriculturalChemicalMfg]:
    '325300 - Pesticide, Fertilizer & Agricultural Chemical Manufacturing',
  [IRSBusinessActivityCode.PharmaceuticalAndMedicinalMfg]:
    '325410 - Pharmaceutical & Medicinal Manufacturing',
  [IRSBusinessActivityCode.ResinSyntheticRubberAndArtificialAndSyntheticFibersAndFilamentsMfg]:
    '325200 - Resin, Synthetic Rubber & Fibers Manufacturing',
  [IRSBusinessActivityCode.SoapCleaningCompoundAndToiletPreparationMfg]:
    '325600 - Soap, Cleaning Compound & Toilet Preparation Manufacturing',
  [IRSBusinessActivityCode.OtherChemicalProductAndPreparationMfg]:
    '325900 - Other Chemical Product & Preparation Manufacturing',
  [IRSBusinessActivityCode.AnimalFoodMfg]: '311110 - Animal Food Manufacturing',
  [IRSBusinessActivityCode.BakeriesTortillaAndDryPastaMfg]:
    '311800 - Bakeries, Tortilla & Dry Pasta Manufacturing',
  [IRSBusinessActivityCode.DairyProductMfg]:
    '311500 - Dairy Product Manufacturing',
  [IRSBusinessActivityCode.FruitAndVegetablePreservingAndSpecialtyFoodMfg]:
    '311400 - Fruit & Vegetable Preserving & Specialty Food Manufacturing',
  [IRSBusinessActivityCode.GrainAndOilseedMilling]:
    '311200 - Grain & Oilseed Milling',
  [IRSBusinessActivityCode.AnimalSlaughteringAndProcessing]:
    '311610 - Animal Slaughtering & Processing',
  [IRSBusinessActivityCode.SeafoodProductPreparationAndPackaging]:
    '311710 - Seafood Product Preparation & Packaging',
  [IRSBusinessActivityCode.SugarAndConfectionaryProductMfg]:
    '311300 - Sugar & Confectionery Product Manufacturing',
  [IRSBusinessActivityCode.OtherFoodMfg]: '311900 - Other Food Manufacturing',
  [IRSBusinessActivityCode.FootwearMfg]: '316210 - Footwear Manufacturing',
  [IRSBusinessActivityCode.LeatherAndHideTanningAndFinishing]:
    '316110 - Leather & Hide Tanning & Finishing',
  [IRSBusinessActivityCode.OtherLeatherAndAlliedProductMfg]:
    '316990 - Other Leather & Allied Product Manufacturing',
  [IRSBusinessActivityCode.CementAndConcreteProductMfg]:
    '327300 - Cement & Concrete Product Manufacturing',
  [IRSBusinessActivityCode.ClayProductAndRefractoryMfg]:
    '327100 - Clay Product & Refractory Manufacturing',
  [IRSBusinessActivityCode.GlassAndGlassProductMfg]:
    '327210 - Glass & Glass Product Manufacturing',
  [IRSBusinessActivityCode.LimeAndGypsumProductMfg]:
    '327400 - Lime & Gypsum Product Manufacturing',
  [IRSBusinessActivityCode.OtherNonmetallicMineralProductMfg]:
    '327900 - Other Nonmetallic Mineral Product Manufacturing',
  [IRSBusinessActivityCode.CoalMining]: '212110 - Coal Mining',
  [IRSBusinessActivityCode.CrudePetroleumExtraction]:
    '211120 - Crude Petroleum Extraction',
  [IRSBusinessActivityCode.MetalOreMining]: '212200 - Metal Ore Mining',
  [IRSBusinessActivityCode.NaturalGasExtraction]:
    '211130 - Natural Gas Extraction',
  [IRSBusinessActivityCode.NonmetallicMineralMiningAndQuarrying]:
    '212300 - Nonmetallic Mineral Mining & Quarrying',
  [IRSBusinessActivityCode.SupportActivitiesForMining]:
    '213110 - Support Activities for Mining',
  [IRSBusinessActivityCode.BarberShops]: '812111 - Barber Shops',
  [IRSBusinessActivityCode.BeautySalons]: '812112 - Beauty Salons',
  [IRSBusinessActivityCode.CemetariesAndCrematories]:
    '812220 - Cemeteries & Crematories',
  [IRSBusinessActivityCode.CoinOperatedLaundriesAndDryCleaners]:
    '812310 - Coin-Operated Laundries & Dry Cleaners',
  [IRSBusinessActivityCode.DryCleaningAndLaundryServices]:
    '812320 - Dry Cleaning & Laundry Services',
  [IRSBusinessActivityCode.FuneralHomesAndFuneralServices]:
    '812210 - Funeral Homes & Funeral Services',
  [IRSBusinessActivityCode.LinenAndUniformSupply]:
    '812330 - Linen & Uniform Supply',
  [IRSBusinessActivityCode.NailSalons]: '812113 - Nail Salons',
  [IRSBusinessActivityCode.ParkingLotsAndGarages]:
    '812930 - Parking Lots & Garages',
  [IRSBusinessActivityCode.PetCare]: '812910 - Pet Care',
  [IRSBusinessActivityCode.Photofinishing]: '812920 - Photofinishing',
  [IRSBusinessActivityCode.OtherPersonalCareServices]:
    '812190 - Other Personal Care Services',
  [IRSBusinessActivityCode.AllOtherPersonalServices]:
    '812990 - All Other Personal Services',
  [IRSBusinessActivityCode.AutomotiveBodyPaintInteriorAndGlassRepair]:
    '811120 - Automotive Body, Paint, Interior & Glass Repair',
  [IRSBusinessActivityCode.AutomotiveMechanicalAndElectricalRepairAndMaintenance]:
    '811110 - Automotive Mechanical & Electrical Repair',
  [IRSBusinessActivityCode.OtherAutomotiveRepairAndMaintenance]:
    '811190 - Other Automotive Repair & Maintenance',
  [IRSBusinessActivityCode.CommercialAndIndustrialMachineryAndEquipmentRepairAndMaintenance]:
    '811310 - Commercial & Industrial Machinery Repair',
  [IRSBusinessActivityCode.ElectronicAndPrecisionEquipmentRepairAndMaintenance]:
    '811210 - Electronic & Precision Equipment Repair',
  [IRSBusinessActivityCode.FootwearAndLeatherGoodsRepair]:
    '811430 - Footwear & Leather Goods Repair',
  [IRSBusinessActivityCode.HomeAndGardenEquipmentAndApplianceRepairAndMaintenance]:
    '811410 - Home & Garden Equipment & Appliance Repair',
  [IRSBusinessActivityCode.ReupholsteryAndFurnitureRepair]:
    '811420 - Reupholstery & Furniture Repair',
  [IRSBusinessActivityCode.OtherPersonalAndHouseholdGoodsRepairAndMaintenance]:
    '811490 - Other Personal & Household Goods Repair',
  [IRSBusinessActivityCode.LegalServices]: '541100 - Legal Services',
  [IRSBusinessActivityCode.OfficesOfCertifiedPublicAccountants]:
    '541211 - Offices of Certified Public Accountants',
  [IRSBusinessActivityCode.PayrollServices]: '541214 - Payroll Services',
  [IRSBusinessActivityCode.TaxPreparationServices]:
    '541213 - Tax Preparation Services',
  [IRSBusinessActivityCode.OtherAccountingServices]:
    '541219 - Other Accounting Services',
  [IRSBusinessActivityCode.ArchitecturalServices]:
    '541310 - Architectural Services',
  [IRSBusinessActivityCode.BuildingInspectionServices]:
    '541350 - Building Inspection Services',
  [IRSBusinessActivityCode.DraftingServices]: '541340 - Drafting Services',
  [IRSBusinessActivityCode.EngineeringServices]:
    '541330 - Engineering Services',
  [IRSBusinessActivityCode.GeophysicalSurveyingAndMappingServices]:
    '541360 - Geophysical Surveying & Mapping Services',
  [IRSBusinessActivityCode.LandscapeArchitectureServices]:
    '541320 - Landscape Architecture Services',
  [IRSBusinessActivityCode.SurveyingAndMappingExceptGeophysicalServices]:
    '541370 - Surveying & Mapping (Except Geophysical)',
  [IRSBusinessActivityCode.TestingLaboratoriesAndServices]:
    '541380 - Testing Laboratories & Services',
  [IRSBusinessActivityCode.ComputerSystemsDesignAndRelatedServices]:
    '541510 - Computer Systems Design & Related Services',
  [IRSBusinessActivityCode.SpecializedDesignServices]:
    '541400 - Specialized Design Services',
  [IRSBusinessActivityCode.AdvertisingPublicRelationsAndRelatedServices]:
    '541800 - Advertising, Public Relations & Related Services',
  [IRSBusinessActivityCode.ManagementScientificAndTechnicalConsultingServices]:
    '541600 - Management, Scientific & Technical Consulting',
  [IRSBusinessActivityCode.MarketResearchAndPublicOpinionPolling]:
    '541910 - Market Research & Public Opinion Polling',
  [IRSBusinessActivityCode.PhotographicServices]:
    '541920 - Photographic Services',
  [IRSBusinessActivityCode.ScientificResearchAndDevelopmentServices]:
    '541700 - Scientific Research & Development Services',
  [IRSBusinessActivityCode.TranslationAndInterpretationServices]:
    '541930 - Translation & Interpretation Services',
  [IRSBusinessActivityCode.VeterinaryServices]: '541940 - Veterinary Services',
  [IRSBusinessActivityCode.AllOtherProfessionalScientificAndTechnicalServices]:
    '541990 - All Other Professional, Scientific & Technical Services',
  [IRSBusinessActivityCode.LessorsOfRealEstate]:
    '531100 - Lessors of Real Estate',
  [IRSBusinessActivityCode.OfficesOfRealEstateAgentsAndBrokers]:
    '531210 - Offices of Real Estate Agents & Brokers',
  [IRSBusinessActivityCode.OfficesOfRealEstateAppraisers]:
    '531320 - Offices of Real Estate Appraisers',
  [IRSBusinessActivityCode.RealEstatePropertyManagers]:
    '531310 - Real Estate Property Managers',
  [IRSBusinessActivityCode.OtherActivitiesRelatedToRealEstate]:
    '531390 - Other Activities Related to Real Estate',
  [IRSBusinessActivityCode.AutomotiveEquipmentRentalAndLeasing]:
    '532100 - Automotive Equipment Rental & Leasing',
  [IRSBusinessActivityCode.CommercialAndIndustrialMachineryAndEquipmentRentalAndLeasing]:
    '532400 - Commercial & Industrial Machinery Rental & Leasing',
  [IRSBusinessActivityCode.ConsumerElectronicsAndAppliancesRental]:
    '532210 - Consumer Electronics & Appliances Rental',
  [IRSBusinessActivityCode.FormalWearAndCostumeRental]:
    '532281 - Formal Wear & Costume Rental',
  [IRSBusinessActivityCode.GeneralRentalCenters]:
    '532310 - General Rental Centers',
  [IRSBusinessActivityCode.HomeHealthEquipmentRental]:
    '532283 - Home Health Equipment Rental',
  [IRSBusinessActivityCode.RecreationalGoodsRental]:
    '532284 - Recreational Goods Rental',
  [IRSBusinessActivityCode.VideoTapeAndDiscRental]:
    '532282 - Video Tape & Disc Rental',
  [IRSBusinessActivityCode.OtherConsumerGoodsRental]:
    '532289 - Other Consumer Goods Rental',
  [IRSBusinessActivityCode.ReligiousGrantmakingCivicProfessionalAndSimilarOrganizations]:
    '813000 - Religious, Grantmaking, Civic & Professional Organizations',
  [IRSBusinessActivityCode.HardwareRetailers]: '444140 - Hardware Retailers',
  [IRSBusinessActivityCode.HomeCenters]: '444110 - Home Centers',
  [IRSBusinessActivityCode.LawnAndGardenEquipmentAndSuppliesRetailers]:
    '444200 - Lawn & Garden Equipment & Supplies Retailers',
  [IRSBusinessActivityCode.PaintAndWallpaperRetailers]:
    '444120 - Paint & Wallpaper Retailers',
  [IRSBusinessActivityCode.OtherBuildingMaterialsDealers]:
    '444180 - Other Building Materials Dealers',
  [IRSBusinessActivityCode.ClothingAndClothingAccessoriesRetailers]:
    '458110 - Clothing & Clothing Accessories Retailers',
  [IRSBusinessActivityCode.JewelryRetailers]: '458310 - Jewelry Retailers',
  [IRSBusinessActivityCode.LuggageAndLeatherGoodsRetailers]:
    '458320 - Luggage & Leather Goods Retailers',
  [IRSBusinessActivityCode.ShoeRetailers]: '458210 - Shoe Retailers',
  [IRSBusinessActivityCode.ElectronicAndApplianceRetailers]:
    '449210 - Electronic & Appliance Retailers',
  [IRSBusinessActivityCode.BeerWineAndLiquorRetailers]:
    '445320 - Beer, Wine & Liquor Retailers',
  [IRSBusinessActivityCode.FishAndSeafoodRetailers]:
    '445250 - Fish & Seafood Retailers',
  [IRSBusinessActivityCode.FruitAndVegetableRetailers]:
    '445230 - Fruit & Vegetable Retailers',
  [IRSBusinessActivityCode.GroceryAndConvenienceRetailers]:
    '445100 - Grocery & Convenience Retailers',
  [IRSBusinessActivityCode.MeatRetailers]: '445240 - Meat Retailers',
  [IRSBusinessActivityCode.OtherSpecialtyFoodRetailers]:
    '445290 - Other Specialty Food Retailers',
  [IRSBusinessActivityCode.VendingMachineOperators]:
    '445132 - Vending Machine Operators',
  [IRSBusinessActivityCode.FurnitureRetailers]: '449110 - Furniture Retailers',
  [IRSBusinessActivityCode.HomeFurnishingRetailers]:
    '449120 - Home Furnishing Retailers',
  [IRSBusinessActivityCode.GasolineStations]: '457100 - Gasoline Stations',
  [IRSBusinessActivityCode.FuelDealers]: '457210 - Fuel Dealers',
  [IRSBusinessActivityCode.GeneralMerchandiseRetailers]:
    '455000 - General Merchandise Retailers',
  [IRSBusinessActivityCode.CosmeticsBeautySuppliesAndPerfumeRetailers]:
    '456120 - Cosmetics, Beauty Supplies & Perfume Retailers',
  [IRSBusinessActivityCode.OpticalGoodsRetailers]:
    '456130 - Optical Goods Retailers',
  [IRSBusinessActivityCode.PharmaciesAndDrugRetailers]:
    '456110 - Pharmacies & Drug Retailers',
  [IRSBusinessActivityCode.OtherHealthAndPersonalCareRetailers]:
    '456190 - Other Health & Personal Care Retailers',
  [IRSBusinessActivityCode.AutomotivePartsAccessoriesAndTireRetailers]:
    '441300 - Automotive Parts, Accessories & Tire Retailers',
  [IRSBusinessActivityCode.BoatDealers]: '441222 - Boat Dealers',
  [IRSBusinessActivityCode.MotorcycleAtvAndAllOtherMotorVehicleDealers]:
    '441227 - Motorcycle, ATV & All Other Motor Vehicle Dealers',
  [IRSBusinessActivityCode.NewCarDealers]: '441110 - New Car Dealers',
  [IRSBusinessActivityCode.RecreationalVehicleDealers]:
    '441210 - Recreational Vehicle Dealers',
  [IRSBusinessActivityCode.UsedCarDealers]: '441120 - Used Car Dealers',
  [IRSBusinessActivityCode.BookRetailersAndNewsDealers]:
    '459210 - Book Retailers & News Dealers',
  [IRSBusinessActivityCode.HobbyToyAndGameRetailers]:
    '459120 - Hobby, Toy & Game Retailers',
  [IRSBusinessActivityCode.MusicalInstrumentAndSuppliesRetailers]:
    '459140 - Musical Instrument & Supplies Retailers',
  [IRSBusinessActivityCode.SewingNeedleworkAndPieceGoodsRetailers]:
    '459130 - Sewing, Needlework & Piece Goods Retailers',
  [IRSBusinessActivityCode.SportingGoodsRetailers]:
    '459110 - Sporting Goods Retailers',
  [IRSBusinessActivityCode.ArtDealers]: '459920 - Art Dealers',
  [IRSBusinessActivityCode.Florists]: '459310 - Florists',
  [IRSBusinessActivityCode.GiftNoveltyAndSouvenirRetailers]:
    '459420 - Gift, Novelty & Souvenir Retailers',
  [IRSBusinessActivityCode.ManufacturedHomeDealers]:
    '459930 - Manufactured Home Dealers',
  [IRSBusinessActivityCode.OfficeSuppliesAndStationeryRetailers]:
    '459410 - Office Supplies & Stationery Retailers',
  [IRSBusinessActivityCode.PetAndPetSuppliesRetailers]:
    '459910 - Pet & Pet Supplies Retailers',
  [IRSBusinessActivityCode.UsedMerchandiseRetailers]:
    '459510 - Used Merchandise Retailers',
  [IRSBusinessActivityCode.AllOtherMiscellaneousRetailers]:
    '459990 - All Other Miscellaneous Retailers',
  [IRSBusinessActivityCode.AirTransportation]: '481000 - Air Transportation',
  [IRSBusinessActivityCode.CharterBusIndustry]: '485510 - Charter Bus Industry',
  [IRSBusinessActivityCode.GeneralFreightTruckingLocal]:
    '484110 - General Freight Trucking, Local',
  [IRSBusinessActivityCode.GeneralFreightTruckingLongDistance]:
    '484120 - General Freight Trucking, Long-Distance',
  [IRSBusinessActivityCode.InterurbanAndRuralBusTransportation]:
    '485210 - Interurban & Rural Bus Transportation',
  [IRSBusinessActivityCode.PipelineTransportation]:
    '486000 - Pipeline Transportation',
  [IRSBusinessActivityCode.RailTransportation]: '482110 - Rail Transportation',
  [IRSBusinessActivityCode.ScenicAndSightseeingTransportation]:
    '487000 - Scenic & Sightseeing Transportation',
  [IRSBusinessActivityCode.SchoolAndEmployeeBusTransportation]:
    '485410 - School & Employee Bus Transportation',
  [IRSBusinessActivityCode.SpecializedFreightTrucking]:
    '484200 - Specialized Freight Trucking',
  [IRSBusinessActivityCode.TaxiLimousineAndRideSharing]:
    '485300 - Taxi, Limousine & Ride Sharing',
  [IRSBusinessActivityCode.UrbanTransitSystems]:
    '485110 - Urban Transit Systems',
  [IRSBusinessActivityCode.WaterTransportation]:
    '483000 - Water Transportation',
  [IRSBusinessActivityCode.OtherTransitAndGroundPassengerTransportation]:
    '485990 - Other Transit & Ground Passenger Transportation',
  [IRSBusinessActivityCode.SupportActivitiesForTransportation]:
    '488000 - Support Activities for Transportation',
  [IRSBusinessActivityCode.CouriersAndMessengers]:
    '492000 - Couriers & Messengers',
  [IRSBusinessActivityCode.WarehousingAndStorage]:
    '493100 - Warehousing & Storage',
  [IRSBusinessActivityCode.Utilities]: '221000 - Utilities',
  [IRSBusinessActivityCode.FurnitureAndHomeFurnishing]:
    '423200 - Furniture & Home Furnishing Wholesale',
  [IRSBusinessActivityCode.HardwareAndPlumbingAndHeatingEquipmentAndSupplies]:
    '423700 - Hardware, Plumbing & Heating Equipment Wholesale',
  [IRSBusinessActivityCode.HouseholdAppliancesAndElectricalAndElectronicGoods]:
    '423600 - Household Appliances & Electronic Goods Wholesale',
  [IRSBusinessActivityCode.JewelryWatchPreciousStoneAndPreciousMetals]:
    '423940 - Jewelry, Watch & Precious Metals Wholesale',
  [IRSBusinessActivityCode.LumberAndOtherConstructionMaterials]:
    '423300 - Lumber & Construction Materials Wholesale',
  [IRSBusinessActivityCode.MachineryEquipmentAndSupplies]:
    '423800 - Machinery, Equipment & Supplies Wholesale',
  [IRSBusinessActivityCode.MetalAndMineral]:
    '423500 - Metal & Mineral Wholesale',
  [IRSBusinessActivityCode.MotorVehicleAndMotorVehiclePartsAndSupplies]:
    '423100 - Motor Vehicle & Parts Wholesale',
  [IRSBusinessActivityCode.ProfessionalAndCommercialAndEquipmentAndSupplies]:
    '423400 - Professional & Commercial Equipment Wholesale',
  [IRSBusinessActivityCode.RecyclableMaterials]:
    '423930 - Recyclable Materials Wholesale',
  [IRSBusinessActivityCode.SportingAndRecreationalGoodsAndSupplies]:
    '423910 - Sporting & Recreational Goods Wholesale',
  [IRSBusinessActivityCode.ToyAndHobbyGoodsAndSupplies]:
    '423920 - Toy & Hobby Goods Wholesale',
  [IRSBusinessActivityCode.OtherMiscellaneousDurableGoods]:
    '423990 - Other Miscellaneous Durable Goods Wholesale',
  [IRSBusinessActivityCode.ApparelPieceGoodsAndNotions]:
    '424300 - Apparel, Piece Goods & Notions Wholesale',
  [IRSBusinessActivityCode.BeerWineAndDistilledAlcoholicBeverages]:
    '424800 - Beer, Wine & Distilled Alcoholic Beverages Wholesale',
  [IRSBusinessActivityCode.BooksPeriodicalsAndNewspapers]:
    '424920 - Books, Periodicals & Newspapers Wholesale',
  [IRSBusinessActivityCode.ChemicalAndAlliedProducts]:
    '424600 - Chemical & Allied Products Wholesale',
  [IRSBusinessActivityCode.DrugsAndDruggistsSundries]:
    "424210 - Drugs & Druggists' Sundries Wholesale",
  [IRSBusinessActivityCode.FarmProductRawMaterials]:
    '424500 - Farm Product Raw Materials Wholesale',
  [IRSBusinessActivityCode.FarmSupplies]: '424910 - Farm Supplies Wholesale',
  [IRSBusinessActivityCode.FlowerNurseryStockAndFloristsSupplies]:
    "424930 - Flower, Nursery Stock & Florists' Supplies Wholesale",
  [IRSBusinessActivityCode.GroceryAndRelatedProducts]:
    '424400 - Grocery & Related Products Wholesale',
  [IRSBusinessActivityCode.PaintVarnishAndSupplies]:
    '424950 - Paint, Varnish & Supplies Wholesale',
  [IRSBusinessActivityCode.PaperAndPaperProducts]:
    '424100 - Paper & Paper Products Wholesale',
  [IRSBusinessActivityCode.PetroleumAndPetroleumProducts]:
    '424700 - Petroleum & Petroleum Products Wholesale',
  [IRSBusinessActivityCode.TobaccoProductsAndElectronicCigarettes]:
    '424940 - Tobacco Products & Electronic Cigarettes Wholesale',
  [IRSBusinessActivityCode.OtherMiscellaneousNondurableGoods]:
    '424990 - Other Miscellaneous Nondurable Goods Wholesale',
  [IRSBusinessActivityCode.WholesaleTradeAgentsAndBrokers]:
    '425120 - Wholesale Trade Agents & Brokers',
  [IRSBusinessActivityCode.UnclassifiedEstablishments]:
    '999000 - Unclassified Establishments',
}

export const BUSINESS_ACTIVITY_CODES = Object.entries(
  BUSINESS_ACTIVITY_CODES_MAP,
) as [code: string, label: string][]
